module.exports = __webpack_public_path__ + "media/images/smile-5-dcdc3eb432e63586096cd6b37173288f.svg";